<section class="volvo tabMobSidePadding">
    <div class="volvo-customisationDiv">
        <volvo-allservices-page></volvo-allservices-page>
        <div class="marginB16">
            <img src="assets/pages/services/Customisation.webp" class="volvo-customisationImg"
                alt="{{ 'uk/components/footer/customisation' | lowercase | translate }}" />
        </div>
        <h2 class="pageHeading-h2Heading marginB8">
            {{ "uk/components/footer/customisation" | lowercase | translate }}
        </h2>
        <p class="volvo-text marginB24">
            {{ "uk/pages/services/customisation/text1" | lowercase | translate }}
        </p>
    </div>

    <div class="volvo-list marginB24">
        <div *ngFor="let list of customisationList" class="volvo-list-display-padding selectedEconomySpanMaxWidth">
           <p class="volvo-list-title marginB8"> {{ list.type | lowercase | translate }}</p>
            <p class="volvo-text" >
                {{ list.name | lowercase | translate }}
            </p>
        </div>
        <div id="serviceContract"></div>
    </div>
   
    <p class="volvo-text marginB48" id="volvoConnect">
        {{ "uk/pages/services/customisation/text2" | lowercase | translate }}
    </p>
</section>